module.exports = __webpack_public_path__ + "fd8dfd015953265f1afabb0f99c40251.png";